import React from "react";
import { Form, Button } from "react-bootstrap";

const CommonStructured = ({
  onClickCreateBtn,
  onClickCreateBtn1,
  pageHeading,
  createBtnTxt,
  createBtnTxt1,
  createBtnTxt2,
  onClickCreateBtn2,
  createBtnTxt3,
  onClickCreateBtn3,
  isReload,
  onClickBackBtn,
  isCheckboxBtn,
  isEnableFdCreation,
  setIsFdCreation,
  isLoading,
  onCloseModal,
  // isToggle,
  // setIsToggle,
}) => {
  return (
    <div className="mainContainer">
      <div className="innerContainer">
        <div className="globalGymANdDatesFilterContainer globalGymANdDatesFilterContainerWithM0">
          <div className="renewal-header-gym flexBetween">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <span className="fs-lg-k">{pageHeading}</span>
              {isReload && (
                <button
                  variant="dark"
                  type="button"
                  onClick={isReload}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "#000",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-clockwise"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#fff",
                      fill: "#fff",
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                    />
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                  </svg>
                </button>
              )}
            </div>

            <div className="lastFlex">
              <div className="columsDivsFlexEndFilterContainer gap-2">
                {isCheckboxBtn && (
                  <div className="toggle-header-btn-container">
                    <Form.Check
                      type="checkbox"
                      id={`default-checkbox`}
                      className={`${isEnableFdCreation ? "green" : ""}`}
                      label={`Enable FD Create Option`}
                      checked={isEnableFdCreation}
                      onChange={(e) => setIsFdCreation(e.target.checked)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                {onClickBackBtn && (
                  <Button
                    type="button"
                    variant="dark"
                    className="notmalButtonStyles smallText"
                    onClick={onClickBackBtn}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-left"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "5px" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      />
                    </svg>
                    Back
                  </Button>
                )}

                {/* {isToggle !== undefined && (
                  <div className="toggle-container">
                    <label className="docs-toggle-switch">
                      <input
                        type="checkbox"
                        className="docs-toggle-switch__input"
                        checked={isToggle}
                        onChange={() => setIsToggle(!isToggle)}
                      />
                      <span className="docs-toggle-switch__slider" />
                    </label>
                    <span className="toggle-label">Switch To LMS Beta</span>
                  </div>
                )} */}

                {createBtnTxt && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onClickCreateBtn}
                  >
                    {createBtnTxt}
                  </Button>
                )}

                {createBtnTxt2 && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onClickCreateBtn2}
                  >
                    {createBtnTxt2}
                  </Button>
                )}

                {createBtnTxt3 && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onClickCreateBtn3}
                  >
                    {createBtnTxt3}
                  </Button>
                )}

                {createBtnTxt1 && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onClickCreateBtn1}
                    style={{
                      background: createBtnTxt1 === "Reload" ? "#7D7C7C" : "",
                      border:
                        createBtnTxt1 === "Reload" ? "1px solid #B4B4B8" : "",
                    }}
                  >
                    {createBtnTxt1 === "Reload" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise small-icon"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                      </svg>
                    ) : null}
                    {createBtnTxt1}
                  </Button>
                )}

                {onCloseModal && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onCloseModal}
                    style={{
                      height: "50px",
                      width: "50px",
                      background: "#171717",
                      border: "none",
                      borderRadius: "50%",
                    }}
                  >
                    X
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonStructured;
